import { useWindowDimensions } from 'react-native'
import type { Size, Breakpoints } from './types'

const DefaultBreakpoints: Breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
}

type Props = {
  breakpoints?: Breakpoints
}
const useResponsiveScreen = ({ breakpoints = DefaultBreakpoints }: Props) => {
  const { width, height } = useWindowDimensions()

  const isLandscape = width > height
  const isPortrait = width < height

  const screenSize = ((): Size => {
    if (width >= breakpoints.xs && width <= breakpoints.sm) {
      return 'xs'
    } else if (width >= breakpoints.sm && width <= breakpoints.md) {
      return 'sm'
    } else if (width >= breakpoints.md && width <= breakpoints.lg) {
      return 'md'
    } else if (width >= breakpoints.lg && width <= breakpoints.xl) {
      return 'lg'
    } else {
      return 'xl'
    }
  })()

  return {
    isLandscape,
    isPortrait,
    screenSize,
  }
}

export default useResponsiveScreen
